import BaseApiService from "./base-services/baseApi.service";

class TestApiService extends BaseApiService {
    constructor() {
        super();
    }

    getTestDetails = async (payload, config) => {
        const url = `/website/test/detail`;
        const res = await this.axiosInstance.post(url, payload, config);
        return res;
    };

    getLabTestCityDetail = async (params, config) => {
        const url = `/website/lab-test/city-detail`;
        const res = await this.axiosInstance.get(url, { ...config, params });
        return res;
    };

    getHealthPackages = async () => {
        const url = `/website/health-packages`;
        const res = await this.axiosInstance.get(url);
        return res?.data;
    };

    getPatientList = async () => {
        const url = `/access/all-patients`;
        const res = await this.axiosInstance.get(url);
        return res;
    };

    createPatient = async (payload) => {
        const url = `/access/create-patient`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    addToCentreCart = async ({ payload }) => {
        const url = `/order/cart/add-centre-item`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    addToCentreCartPopUp = async (payload) => {
        const url = `/order/cart/add-centre-item`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    addToHomeCart = async ({ payload }) => {
        const url = `/order/cart/add-home-item`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    getCart = async () => {
        const url = `/order/cart`;
        const res = await this.axiosInstance.get(url);
        return res;
    };

    updateCartFromSession = async ({ payload }) => {
        const url = `/order/cart/update-cart-from-session`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    updateSessionFromCart = async ({ payload }) => {
        const url = `/order/cart/update-session-from-cart`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    updateHomeAddress = async ({ payload }) => {
        const url = `/order/cart/update-home-address`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };
}
const testApiService = new TestApiService();
export { testApiService };
